<template>

  <section class="list-view row-center">

    <div class="contenedor-listado" :style="styles.backgroundWhite" :full="fichaView.full">
      <div class="scroll-container" v-if="!!ofertas">
        <contenedor-tabla :data="ofertas" :typeOffer="this.$route.params.status"></contenedor-tabla>
      </div>
    </div>

    <div class="contenedor-ficha" :style="ownstyle.ficha" v-if="showoferta">

      <div class="settings row-end" :style="styles.colorSoftBasic">
        <router-link :to="$t('enlaces.ofertaspracticas')" title="Cerrar ficha">✕</router-link>
      </div>

      <div class="scroll-container">
        <ficha-oferta></ficha-oferta>
      </div>

    </div>


  </section>


</template>

<script>

  import { mapGetters } from 'vuex'

  import fichaoferta from '@/components/views/ficha-oferta-cf'
  import contenedortabla from '@/components/views/contenedor-tabla-ofertas'

  export default {
    name: 'ofertas-cf',
    props:['status'],
    data: () => ({
      fichaView: {
        full: true,
        view: false,
        id: ''
      },
    }),
    components: {
      'ficha-oferta': fichaoferta,
      'contenedor-tabla': contenedortabla
    },
    computed: {
      ...mapGetters({
        ofertasCon: 'getOfertasConDatos',
        ofertasSin: 'getOfertasSinDatos',
        styles: 'getStyles',
        colors: 'basicColors'
      }),
      ownstyle: function () {
        return {
          ficha: {
            'border-left': `10px solid ${this.colors.backgroundBody}`,
            background: this.colors.white
          },
          vistaEncuesta: {
            'border-left': `10px solid ${this.colors.backgroundBody}`,
            background: this.colors.white
          }
        }
      },
      ofertas() {

        let ofertas;

        if (this.$route.params.status == 'pendientes') {
          ofertas = this.ofertasCon;
        } else if (this.$route.params.status == 'tramitadas') {
          ofertas = this.ofertasSin;
        } else {
          ofertas = this.ofertasCon.concat(this.ofertasSin);
        }

        return ofertas;
      },
      showoferta() {
        let notallow = ['pendientes', 'tramitadas'];
        let show = false;
        if (this.$route.params.id) {
          show = true;
        }

        if (this.$route.params.status) {
          if (!notallow.some(e => e == this.$route.params.status)) {
            show = true;
          }
        }

        return show;


      }
    },
    filters: {
      date(value) {
        return value.split(" ")[0]
      }
    },

  }
</script>

<style lang="scss" scoped>
  .list-view {
    width: 100%;
    height: 100%;
    -webkit-flex-wrap: nowrap;
    -moz-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    -o-flex-wrap: nowrap;
    flex-wrap: nowrap;
    max-height: 100%;
    position: relative;

  }


  .contenedor-listado {
    width: 100%;
    height: 100%;
    display: inline-block;
    overflow: hidden;
    padding: 20px;

    &[showEncuesta=true] {
      width: auto;
    }
  }

  .contenedor-ficha {
    width: 100%;
    height: 100%;
    display: inline-block;
    max-width: 600px;
    min-width: 500px;
    overflow: hidden;
    padding: 10px;
    position: relative;

    .settings {
      padding-right: 13px;
    }


    &[full="true"] {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 7;
      max-width: 100%;
      border-left: none !important;
    }


  }

  .scroll-container {
    width: 100%;
    height: 100%;
    min-height: 100%;
    display: inline-block;
    overflow: hidden;
  }


  .contenedor-ficha .scroll-container {
    overflow: scroll;
  }

  .settings {
    position: absolute;
    right: 5px;
    top: 0;
    height: 30px;
    width: 100px;
    z-index: 5;
  }

  .settings a {
    width: 25px;
    height: 30px;
    display: inline-block;
    line-height: 30px;
  }

  .contenedor-vista-encuesta {
    width: 100%;
    height: 100%;
    max-width: 600px;
    min-width: 500px;
    overflow: hidden;
    position: relative;
    flex-grow: 2;

    &[full="true"] {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 5;
      max-width: 100%;
      border-left: none !important;
    }
  }

  .tabla-responsive {
    display: none;
  }

  @media screen and (max-height: 900) {
    .contenedor-listado {
      .tabla-responsive {
        display: inline-block;
        width: 100%;
      }

      .tabla-pc {
        display: none;
      }
    }
  }

  @media screen and (max-width: 1400px) {
    .contenedor-listado {
      &[showEncuesta=true] {
        display: none;
      }
    }

    .contenedor-ficha {
      max-width: 100%;

      &[showEncuesta=true] {
        border-left: none !important;
      }
    }

    .contenedor-vista-encuesta {
      max-width: 100%;
    }

  }

  @media screen and (max-width: 1200px) {
    .contenedor-listado[hasFicha="true"] {
      .tabla-responsive {
        display: inline-block;
        width: 100%;
      }

      .tabla-pc {
        display: none;
      }
    }
  }

  @media screen and (max-width: 1023px) {
    .contenedor-listado {
      &[hasFicha=true] {
        display: none;
      }
    }

    .contenedor-listado {
      .tabla-responsive {
        display: inline-block;
        width: 100%;
      }

      .tabla-pc {
        display: none;
      }
    }


    .contenedor-ficha[showEncuesta="true"] {
      display: none;
    }

    .settings .icon-ampliar {
      display: none;
    }

    .contenedor-ficha {
      border-left: none !important;
      min-width: 0;
    }

    .contenedor-vista-encuesta {
      min-width: 0;
      border-left: none !important;
    }

  }

  @media screen and (max-width: 600px) {
    .contenedor-listado {
      padding: 10px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/ofertas-cf.vue